class Response {
  constructor(statusCode, payload) {
    let error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    this.statusCode = statusCode;
    this.payload = payload;
    this.error = error;
  }

}

module.exports = Response;